var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.svgFile)}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }